import { taxTabs } from "./tax-tabs";
import { components } from "./components";
import { newPageNotificationModal } from "./new-page-notification-modal";

export const fiscalData = {
	components,
	taxTabs,
	newPageNotificationModal,
	titlePage: "Dados Fiscais",
	titlesTabs: {
		taxCouvert: "Dados fiscais de couvert",
		taxGroups: "Grupos fiscais de produto",
		taxProfiles: "Perfis fiscais",
		minimumConsummation: "Consumação mínima",
		recharge: "Recarga",
	},
};
